module.exports = "/images/logo_new_top.png?d528327435ec744609bb212332a4b40d";